/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Check_Email_ErrorInputs */

const en_admin_create_company_user_check_email_error = /** @type {(inputs: Admin_Create_Company_User_Check_Email_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while checking the email.`)
};

const de_admin_create_company_user_check_email_error = /** @type {(inputs: Admin_Create_Company_User_Check_Email_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Prüfen der E-Mail-Adresse ist ein Fehler aufgetreten.`)
};

/**
* | output |
* | --- |
* | "An error occurred while checking the email." |
*
* @param {Admin_Create_Company_User_Check_Email_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_check_email_error = /** @type {((inputs?: Admin_Create_Company_User_Check_Email_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Check_Email_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_check_email_error(inputs)
	return en_admin_create_company_user_check_email_error(inputs)
});